const getDesignTokens = (mode) => ({
  palette: {
    mode,
    primary: {
      main: '#D4AF37', // gold
      light: '#FFE08A',
      dark: '#A27F24',
      contrastText: '#000000',
    },
    secondary: {
      main: '#FFFFFF',
      contrastText: '#000000',
    },
    background: {
      ...(mode === 'dark'
        ? {
            default: '#121212',
            paper: '#1e1e1e',
          }
        : {
            default: '#FFFFFF',
            paper: '#F5F5F5',
          }),
    },
    text: {
      ...(mode === 'dark'
        ? {
            primary: '#FFFFFF',
            secondary: '#B0B0B0',
          }
        : {
            primary: '#000000',
            secondary: '#555555',
          }),
    },
  },
});

export default getDesignTokens;
